import { apiContractRequest } from "./client";

export const ownerFinanceStatsApi = {
  history({ start = "", end = "", currency = "", accountId = "", bucket = "month" } = {}) {
    return apiContractRequest("/api/owner/finance/stats/history", {
      params: {
        ...(start ? { start } : {}),
        ...(end ? { end } : {}),
        ...(currency ? { currency } : {}),
        ...(accountId ? { accountId } : {}),
        bucket,
      },
    });
  },
  future({ month = "", currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/finance/stats/future", { params: { month, currency, tzOffsetMinutes } });
  },
  updateFutureTarget(payload = {}) {
    return apiContractRequest("/api/owner/finance/stats/future/target", {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: payload,
    });
  },
  accounts() {
    return apiContractRequest("/api/owner/finance/accounts", { params: { includeArchived: true } });
  },
};
